import { AcceptOrRejectMultipleOffersResponseDto, OFFER_LIST_TYPE } from "pages/project/offer/offer.typing";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useAcceptOfferMutation, useAcceptMultipleOffersMutation } from "query/offer.query";

export interface AcceptFormModel {
  comment?: string;
}

export const useAcceptOfferForm = (offerId: string) => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { register, reset, handleSubmit } = useForm<AcceptFormModel>();

  const onReset = () => {
    reset();
    navigate(`/project/offer/list/${OFFER_LIST_TYPE.pending}/?${params.toString()}`);
  };

  const onSuccess = () => {
    reset();
    navigate(`/project/offer/list/${OFFER_LIST_TYPE.accepted}?${params.toString()}`);
  };

  const { mutate, ...others } = useAcceptOfferMutation(offerId, onSuccess);

  return { ...others, register, reset: onReset, accept: handleSubmit((params) => mutate(params)) };
};

export const useAcceptMultipleOffersForm = (
  offerIds: string[],
  onClose: () => void,
  onError: (error: AcceptOrRejectMultipleOffersResponseDto) => void
) => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { register, reset, handleSubmit } = useForm<AcceptFormModel>();

  const onSuccess = () => {
    reset();
    navigate(`/project/offer/list/${OFFER_LIST_TYPE.accepted}?${params.toString()}`);
    onClose?.();
  };

  const { mutate, ...others } = useAcceptMultipleOffersMutation(offerIds, onSuccess, onError);

  return { ...others, register, reset, accept: handleSubmit((params) => mutate(params)) };
};
